import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

// SSO 서비스 ID (MOI 앱)
const SERVICE_ID = "MOI";

export class UserRepository {
    // WIZ-SSO API
    static onSsoLogin = (params: { email: string; password: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoLogin'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                userId: params.email,
                password: params.password,
                deviceId: params.deviceId || 'web-device',
                os: params.os || 'web'
            }
        })
    }

    static onSsoSocialLogin = (params: { provider: string; providerUserId: string; providerAccessToken: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoSocialLogin'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                provider: params.provider,
                providerUserId: params.providerUserId,
                providerAccessToken: params.providerAccessToken,
                deviceId: params.deviceId || 'web-device',
                os: params.os || 'web'
            }
        })
    }

    static onSsoSignup = (params: { email: string; password: string; nickname: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoSignup'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                snsLogin: false,
                email: params.email,
                password: params.password,
                nickname: params.nickname,
                deviceId: params.deviceId || 'web-device',
                os: params.os || 'web'
            }
        })
    }

    static onSsoRefresh = (refreshToken: string) => {
        return onRequest({
            url: getApiUrl('ssoRefresh'),
            method: RequestMethod.POST,
            params: { refreshToken }
        })
    }

    static onSsoLogout = (accessToken: string, provider?: string) => {
        return onRequest({
            url: getApiUrl('ssoRevoke'),
            method: RequestMethod.POST,
            params: { accessToken, provider: provider || 'EMAIL' }
        })
    }

    // SSO 회원정보 조회
    static onGetSsoUser = (accessToken: string) => {
        return onRequest({
            url: getApiUrl('ssoUser'),
            method: RequestMethod.GET,
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        })
    }
}